<template>
  <div id="app" :style="vhProperty">
    <transition name="modal-fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
// import Player from '@vimeo/player';
import Keycloak from 'keycloak-js';
import { Base64 } from 'js-base64';
import { KEYCLOCK_URL, KEYCLOCK_REALM_NAME, KEYCLOCK_CLIENT_ID, APP_ID } from './config';
import axios from 'axios';
export default {
  name: 'engine',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Default Title',
    // all titles will be injected into this template
    titleTemplate: '%s | My Awesome Webapp',
  },

  created() {
    this.onResize();
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    if (process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'app') {
      // this.login wyłączony na wieczność
      // this.login();
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  data() {
    return {
      vh: 0,
    };
  },
  methods: {
    onResize() {
      this.vh = window.innerHeight / 100;
    },
    login() {
      var keycloak = Keycloak({
        realm: `${KEYCLOCK_REALM_NAME}`,
        url: `${KEYCLOCK_URL}`,
        clientId: `${KEYCLOCK_CLIENT_ID}`,
        'ssl-required': 'all',
        resource: `${KEYCLOCK_CLIENT_ID}`,
        'public-client': true,
        'confidential-port': 0,
      });

      keycloak
        .init({
          promiseType: 'native',
          onLoad: 'login-required',
        })
        .then((authenticated) => {
          let decodedToken = this.decodeToken(keycloak.token);
          let redaktor = decodedToken.realm_access.roles.includes('ROLE_MULTIMEDIA_EDITOR');
          if (process.env.VUE_APP_MATERIAL_ID) this.request(keycloak.token, redaktor, keycloak.idToken);
          return authenticated;
        })
        .catch((error) => {
          console.error(error);
        });

      keycloak.onTokenExpired = () => {
        keycloak
          .updateToken(30)
          .then((refreshed) => {
            if (refreshed) {
              this.$store.commit('TOKEN_SET', keycloak.token);
            } else {
              console.log('Token is still valid');
            }
          })
          .catch((error) => {
            console.error(error);
          });
      };
    },
    request(token, redaktor, idToken) {
      let data = { authorization: `Bearer ${token}` };
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://multibooki-api.app.mac.pl/api/profile',
        headers: {
          'Content-Type': 'application/json',
          id: process.env.VUE_APP_MATERIAL_ID,
        },
        data: data,
      };
      if (config) {
        axios(config)
          .then((response) => {
            if (!response.data.access && !redaktor) {
              this.$store.commit('SET_MATERIAL_ACCESS', 'false');
              this.$router.push({ name: 'error', params: { idToken: idToken } });
            } else {
              this.$store.commit('SET_MATERIAL_ACCESS', 'true');
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    decodeToken(data) {
      let encodedArray = data.split('.');
      return JSON.parse(Base64.decode(encodedArray[1]));
    },
    changeColor() {
      console.log('click');
      return this.inc();
    },
    inc() {
      return this.counter++;
    },
  },
  computed: {
    vhProperty() {
      return { '--vh': `${this.vh}px` };
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  height: calc(100 * var(--vh));
}
.modal-fade-leave-active,
.modal-fade-enter-active {
  transition: all 0.5s linear;
}
.modal-fade-leave-to,
.modal-fade-enter {
  opacity: 0;
}
</style>
